import { getStoreList } from "$merChantApi/tw-merchant-boss/tw-merchant-boss";
import { orderCount, batchOrder } from "$merChantApi/tw-order-boss/tw-order-boss";
import Store from "$common/utils/store";
import JsCrypto from '$proDirname/app/service/util-service/js-crypto';

const jsCrypto = JsCrypto(1, true);

export default {
  async get_store_list({ commit }) {
    let userInfo;
    try {
      userInfo = JSON.parse(jsCrypto.decrypt(Store.loadObject('user_info')));
    } catch (err) {
      userInfo = {};
    }
    try {
      const { rspCd, data } = await getStoreList({})
      if (rspCd + '' === '00000') {
        if (data.merchant?.merchantNo) {
          userInfo.merchantNo = data.merchant.merchantNo
        }
        if (Array.isArray(data.store) && data.store.length) {
          for (const e of data.store) {
            userInfo[e.storeNo] = '1'
          }
        }
        Store.saveObject('user_info', jsCrypto.encrypt(JSON.stringify(userInfo)));
        console.log('data: ', data);
        return data || {}
      }
      return data
    } catch (e) { return {} }
  },
  total_order_count({ commit }) {
    return new Promise((resolve, reject) => {
      orderCount({ storeNo: Store.loadObject('storeNo') }, {
        success: res => {
          if (res.rspCd + '' === '00000') {
            commit('SET_SIDER_BAR_COUNT', res.data)
            resolve(res.data || {})
          }
        },
        fail: res => {
          reject(res)
        }
      })
    })
  },
  auto_receive_order({ commit }) {
    return new Promise((resolve, reject) => {
      batchOrder({ storeNo: Store.loadObject('storeNo'), deliverType: '10' }, {
        success: res => {
          resolve(res)
        },
        fail: res => {
          reject(res)
        }
      }
      )
    })
  }
}
